import Player from '@vimeo/player';

var elms = {
    header: document.querySelector('header'),
    logo: document.querySelector('.logo'),
    nav: document.querySelector('nav'),
    content: document.querySelector('.content'),
    lineOne: document.querySelector('.line-one'), 
    lineTwo: document.querySelector('.line-two'), 
    lineThree: document.querySelector('.line-three'), 
    info: document.querySelector('.info')
}

var firstLoad = true;
var homepage = false;
var letters = {};

var touch = isTouchDevice();


const breakpoint = 767;

if(document.querySelector('.home')){
    homepage = true;
}

window.addEventListener('load', function() {
    header_effect();
    page_load();
});

function page_load(){

    elms = {
        header: document.querySelector('header'),
        logo: document.querySelector('.logo'),
        nav: document.querySelector('nav'),
        content: document.querySelector('.content'),
        lineOne: document.querySelector('.line-one'), 
        lineTwo: document.querySelector('.line-two'), 
        lineThree: document.querySelector('.line-three'), 
        info: document.querySelector('.info')
    };

    header_check();
    bind_nav();
    bind_links();
    reveal();
    check_for_videos();
    
};

window.addEventListener('resize', function() {
    header_check();
});




// document.addEventListener('scroll', function(){
//     header_check();
// });

function check_header(){
    header_check();
    window.requestAnimationFrame(check_header);
}

window.requestAnimationFrame(check_header);

function bind_nav(){
    let navLinks = document.querySelectorAll('.project-link');

    for (let a = 0; a < navLinks.length; a++) {
       navLinks[a].removeEventListener('click', load_page);
       navLinks[a].addEventListener('click', load_page);
    }
}

function load_page(e){
    console.log('click');
    e.preventDefault();

    let curPage = document.querySelector('.content');

    let link = e.target;
    let url = link.href;
    let title = link.dataset.title;

    curPage.style.opacity = 0;

    trigger(link, url, title, false);


    function trigger(link, url, title, preTrans){

        fetch( url + '?ajax=true', {
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(function (response) {
            return response.text();
        })
        .then(function (html) {
            // set the new title of the page

            window.history.pushState({"html":html, "pageTitle": title},"", url);

            let parser = new DOMParser();
            let doc = parser.parseFromString(html, 'text/html');
            let newPage = doc.querySelector('.content');

            let parent =  curPage.parentNode;

            parent.appendChild(newPage);
            parent.removeChild(curPage);
           
            page_load();
            
        })
        .catch(function (err) {
            // console.log(err);
            window.location.href = url;
        });
      

    };

};

function header_effect(){


    let lines = document.querySelectorAll('.line');

    for (let a = 0; a < lines.length; a++) {
        let line = lines[a].querySelectorAll('span');
        for (let b = 0; b < line.length; b++) {
            var originalText =   line[b].innerHTML;
            var wrappedText = wrapLettersInSpan(originalText);
            line[b].innerHTML = wrappedText;
        }
       
    }

    let bs = document.querySelectorAll('b');

    for (let a = 0; a < bs.length; a++) {

       bs[a].addEventListener('mousemove', function(){
        bs[a].style.transition = 'color 0.1s';
        bs[a].style.color = '#0000FF';
       });

       bs[a].addEventListener('mouseleave', function(){
        bs[a].style.transition = 'color 2s';
        bs[a].style.color = '#000000';
       });

       let letter = bs[a].innerHTML.toLowerCase();
        
       if(!letters[letter]){
            letters[letter] = [];
       }

       letters[letter].push(bs[a]);
    }

    console.log(letters);

}




function check_for_videos(){

    var players = document.querySelectorAll('.player');

    for (let a = 0; a < players.length; a++) {

        let elm = players[a];
        let wrap = elm.parentNode;
        let cover = wrap.querySelector('.cover-image');
        let button = wrap.querySelector('.play-button');
        let details = wrap.querySelector('.video-info');

        let coverVideo = wrap.querySelector('.cover-video');

        if(coverVideo){
            const coverVideoOptions = {
                id: coverVideo.dataset.id,
                byline: false, 
                portrait: false,
                resoponsive: true,
                auotplay: true,
                loop: true,
                background: true, 
                controls: false,
                playsinline: true,
                autopause: false,
                muted: true,
                cache: true,
                dnt: true,
                title: false
            };

            var coverPlayer = new Player(coverVideo, coverVideoOptions);

            coverPlayer.on("play", function(data) {
                cover.classList.add('blur');
            });

        }


        const options = {
            id: elm.dataset.id,
            byline: false, 
            portrait: false,
            resoponsive: true,
            loop: false,
            controls: true,
            playsinline: true,
            autopause: false,
            muted: false,
            cache: true,
            dnt: true,
            title: false,
            buttons: {
                share: false
            },
            transparent: true,
            color: 'ffffff'
        };



        var player = new Player(elm, options);



        player.getDuration().then(function(duration) {
            details.innerHTML = secondsToTimecode(duration);
        }).catch(function(error) {
            // an error occurred
        });


        player.on("play", function(data) {
            cover.style.opacity = 0;
            cover.style.pointerEvents = 'none';
            button.style.opacity = 0;
            button.style.pointerEvents = 'none';
            coverVideo.style.opacity = 0;
            if(coverVideo){
                coverPlayer.destroy();
            }
        });

        cover.addEventListener('click', function(){
            player.play();
        });
        
    }

};


function bind_links(){

    let navHover = document.querySelectorAll('.nav-hover');

    for (let a = 0; a < navHover.length; a++) {
        let elm = navHover[a];
        if(!touch){
            elm.addEventListener('mouseenter', show_nav);
        }else{
            elm.addEventListener('click', show_nav);
        }
    }

    if(!touch){
        elms.nav.addEventListener('mouseleave', hide_nav);
    }else{
        elms.nav.addEventListener('mouseleave', hide_nav);
    }

    let serviceLinks = document.querySelectorAll('.service');

    for (let a = 0; a < serviceLinks.length; a++) {
        let elm = serviceLinks[a];

        elm.addEventListener('mouseenter', function(){
            let classes = document.querySelectorAll(`.cat-${elm.dataset.slug}`);
            let cats = document.querySelectorAll(`${elm.dataset.cats}`);
            for (let b = 0; b < classes.length; b++) {
                classes[b].classList.add('highlight');
                
            }
            for (let b = 0; b < cats.length; b++) {
                cats[b].classList.add('highlight');
                
            }
        });

        elm.addEventListener('mouseleave', function(){
            let classes = document.querySelectorAll(`.highlight`);
            for (let b = 0; b < classes.length; b++) {
                classes[b].classList.remove('highlight');
                
            }
        });
    }

};

function header_check(){

    let minHeight = window.innerHeight - 50;
    let logoHeight = elms.logo.offsetHeight;

    if(window.innerWidth < breakpoint){
        elms.info.style.top = logoHeight + 'px';
        logoHeight = logoHeight + elms.info.offsetHeight;
    }else{
        elms.info.style.top = 0 + 'px';
    }

    let navHeight = elms.nav.offsetHeight;

    let headerHeight = navHeight + logoHeight;
    let extraHeight = 0;

    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    elms.content.style.marginTop = headerHeight + 'px';


    let lines = document.querySelectorAll('.line');

    for (let a = 0; a < lines.length; a++) {
        let line = lines[a];
        let height = line.offsetHeight;
        let top = line.getBoundingClientRect().top;
        let hide = headerHeight - (top + height + 50);
        
        if(hide < scrollTop){
            line.classList.add('hidden');
            if(a === 0){
                elms.nav.classList.add('at-top');
            }
        }else{
            if(a === 0){
                elms.nav.classList.remove('at-top');
            }
            line.classList.remove('hidden');
        }
    }

    if(navHeight - 58 > scrollTop ){
        elms.nav.style.top = logoHeight + 'px';
        elms.header.classList.remove('sticking');
    }else{
        elms.header.classList.add('sticking');
        let dif = (headerHeight - 58) - scrollTop;

        if(dif > 0){
            elms.nav.style.top = dif  + 'px';
            elms.header.classList.remove('very-top');
        }else{
            elms.header.classList.add('very-top');
            elms.nav.style.top = 0 + 'px';
        }
    }

};

function reveal(){

    if(document.querySelector('.project-page')){
        
        let logoHeight = elms.logo.offsetHeight;
        let navHeight = elms.nav.offsetHeight;
        // let adjustedNavHeight = navHeight - 30;

        let headerHeight = navHeight + logoHeight;

        setTimeout(function(){
            
            window.scrollTo({top: headerHeight });

        },10)

    
    }

    if(firstLoad && homepage){
        
        let time = 100;

        let lines = elms.logo.querySelectorAll('.line');
        let spans = elms.logo.querySelectorAll('span');
        let bs = elms.logo.querySelectorAll('b');

        for (let a = 0; a < bs.length; a++) {
            bs[a].style.opacity = 0;
        }

        elms.logo.style.opacity = 1;
        
        const shuffleArray = (array) => {
          for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
          }
          return array;
        };
            
        const keys = shuffleArray(Object.keys(letters));
        

        let i = 0;
        for (const k of keys) {
          setTimeout(function () {
            for (let i = 0; i < letters[k].length; i++) {
              letters[k][i].style.opacity = 1;
            }
          }, i * time);
        
          i++;
        }

        setTimeout(function(){
            elms.nav.style.opacity = 1;
            elms.content.style.opacity = 1;
        }, keys.length * time);
        
    }else{
        firstLoad = false;

        setTimeout(function(){
            elms.logo.style.opacity = 1;
            setTimeout(function(){
                elms.nav.style.opacity = 1;
                setTimeout(function(){
                    elms.content.style.opacity = 1;
                }, 500);
            }, 500);
            
        }, 500);
    }

};

function loadVideos(){

    let videos = document.querySelector('.player');

    for (let a = 0; a < videos.length; index++) {
        let elm = videos[a];

        const options = {
            id: elm.dataset.id,
            resoponsive: true,
            loop: true,
            controls: true,
            playsinline: true,
            autopause: false,
            muted: muted,
            cache: true,
            dnt: true
        };
        
    }

}

function hide_nav(e){
    elms.nav.classList.remove('hovering');
    document.body.classList.remove('nav-open');
};

function show_nav(e){
    elms.nav.classList.add('hovering');
    document.body.classList.add('nav-open');
};


function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }


  function secondsToTimecode(seconds) {
    const hours = Math.floor(seconds / 3600);
    const remainingSeconds = seconds % 3600;
    const minutes = Math.floor(remainingSeconds / 60);
    const secondsLeft = remainingSeconds % 60;
  
    let timecode = '';
  
    if (hours > 0) {
      timecode += `${hours.toString().padStart(2, '0')}:`;
    }
  
    timecode += `${minutes.toString().padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`;
  
    return timecode;
  }



function isElementStuck(element) {
    // Get the element's computed styles
    const styles = window.getComputedStyle(element);
    
    // Check if the element has position: sticky
    if (styles.position !== 'sticky') {
      return false;
    }
  
    // Check if any of the scrollable ancestors have reached their scroll limit
    const scrollableAncestors = getScrollableAncestors(element);
    for (const ancestor of scrollableAncestors) {
      const ancestorStyles = window.getComputedStyle(ancestor);
      const scrollHeight = ancestor.scrollHeight;
      const scrollTop = ancestor.scrollTop;
      const clientHeight = ancestor.clientHeight;
  
      const isScrollable = scrollHeight > clientHeight &&
        ancestorStyles.overflowY !== 'visible';
  
      if (isScrollable && (scrollTop > 0 || scrollTop + clientHeight < scrollHeight)) {
        return false;
      }
    }
  
    return true;
  }
  


  const getScrollableAncestors = (element) => {
    const scrollableAncestors = [];
  
    let currentElement = element.parentElement;
    while (currentElement) {
      const { overflowY } = window.getComputedStyle(currentElement);
      if (['scroll', 'auto', 'overlay'].includes(overflowY)) {
        scrollableAncestors.push(currentElement);
      }
      currentElement = currentElement.parentElement;
    }
    return scrollableAncestors;
  };




function wrapLettersInSpan(text) {
    var wrappedText = '';
    
    for (var i = 0; i < text.length; i++) {
      wrappedText += '<b>' + text[i] + '</b>';
    }
    
    return wrappedText;
  }
  

  function isTouchDevice() {
    return (('ontouchstart' in window) || 
            (navigator.maxTouchPoints > 0) || 
            (navigator.msMaxTouchPoints > 0));
  }
